var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Fieldset',{attrs:{"label":"Objetivos el refinamiento"}},[_c('el-input',{attrs:{"rows":"8","type":"textarea","resize":"none"},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }